import { render, staticRenderFns } from "./projectFiles.vue?vue&type=template&id=15829490&scoped=true&"
import script from "./projectFiles.vue?vue&type=script&lang=js&"
export * from "./projectFiles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15829490",
  null
  
)

export default component.exports